import type BroadComponentType from 'owa-bundling/lib/types/BroadComponentType';
import type { ComponentGetter, LazyLoadConfig } from '../schema/ErrorConfig';
import { type ErrorHandlerConfigType } from '../schema/ErrorConfig';
import type { LazyModule } from 'owa-bundling-light';
import type { TraceErrorObject } from 'owa-trace';

export const getOwaLazyErrorConfig = <TProps, TModule, TInnerRef, TPlaceHolderRef = void>(
    lazyModule: LazyModule<TModule>,
    componentGetter: ComponentGetter<TModule, TProps, TInnerRef>,
    placeholder?: BroadComponentType<TProps, TPlaceHolderRef>,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    importErrorHandler?: (reason: any) => void,
    unhandledExceptionHandler?: (error: TraceErrorObject) => void
): LazyLoadConfig<TProps, TModule, TInnerRef, TPlaceHolderRef> => ({
    configType: 2,
    lazyModule,
    componentGetter,
    placeholder,
    importErrorHandler,
    unhandledExceptionHandler,
});
